var render = function (_h,_vm) {var _c=_vm._c;return _c('a',{staticClass:"logo d-flex align-center",attrs:{"href":"/"}},[_c('img',{attrs:{"src":require('@/assets/icons/logo.png'),"height":"42","alt":"logo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }